<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                title="门店信息"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.2rem">
            <!-- <van-cell title="基本信息" is-link @click="basic_information"/> -->
            <van-cell title="门店信息" is-link @click="store_information"/>
            <!-- <van-cell title="员工管理" is-link @click="staff_management"/>
            <van-cell title="我的客服" is-link @click="service_information"/> -->
            <van-cell title="修改密码" is-link @click="change_password"/>
          <van-cell title="解除微信绑定" is-link @click="sign_store"/>
          <van-cell title="开通扫码点餐" is-link @click="open_menu" :value="['未开通','已开通'][list.is_code]"/>
		  <div v-if="this.list.is_code==1">
			  <van-cell center title="微信">
				<template #right-icon>
				  <van-switch v-model="close_wechat" size="24" @change="close_code('close_wechat')"/>
				</template>
			  </van-cell>
			  <van-cell center title="支付宝">
				<template #right-icon>
				  <van-switch v-model="close_alipay" size="24" @change="close_code('close_alipay')"/>
				</template>
			  </van-cell>
			  <van-cell center title="云闪付">
				<template #right-icon>
				  <van-switch v-model="close_unionpay" size="24" @change="close_code('close_unionpay')"/>
				</template>
			  </van-cell>
		  </div>
		  
		  
            <van-cell title="退出登录" is-link @click="sign_out"/>
        </div>
        <!--内容 end-->
    </div>
</template>

<script>
    import {Dialog,Toast,Notify} from 'vant';

    export default {
        name: "MerchantInformation", //商户信息
		data() {
		    return {
		        list:{},
				show:false,
				type:'',
				switch:'',
				close_alipay:'',
				close_unionpay: '',
				close_wechat: '',
		    };
		},
		created() {
			this.isOpenOrder();
			
		},
        methods: {
			isOpenOrder() {
			  this.$http
			    .get("/wechat/api.merchant_info/get_store_info", {
			      params: {
			        merchant_id: window.sessionStorage.getItem("commercialId"),
			        store_id: window.sessionStorage.getItem("store_id"),
			      },
			    })
			    .then((response) => {
			      this.list = response.data.data;
				  if(this.list.close_alipay==1){
				  	this.close_alipay=true
				  }else{
					  this.close_alipay=false
				  }
				  if(this.list.close_unionpay==1){
				  	this.close_unionpay=true
				  }else{
				  	this.close_unionpay=false
				  }
				  if(this.list.close_wechat==1){
				  	this.close_wechat=true
				  }else{
				  	this.close_wechat=false
				  }
			    });
			},
            // 左侧返回
            onClickLeft() {
                this.$router.push("/StoreHomepage");
            },
            // 基本信息
            basic_information() {
                // 跳转至基本信息
                this.$router.push("/StoresBasicInformation");
            },
            // 门店信息
            store_information() {
                // 跳转至门店信息
                this.$router.push("/StoresStoreInformation");
            },
            // 员工管理
            staff_management() {
                // 跳转至员工管理
                this.$router.push("/StaffManagement");
            },
            // 客服信息
            service_information() {
                // 跳转至客服信息
                this.$router.push("/ServiceInformation");
            },
            // 修改密码
            change_password(){
                this.$router.push("/StoresChangePassword")
            },
			
		open_menu(){
			  if(this.list.is_code==1){
				  Dialog.alert({
				    title: '温馨提示',
				    message: '您已开通扫码点餐！',
				  }).then(() => {
				    // on close
				  });
				  this.show=true;
			  }else{
				  Dialog.confirm({
					  title: '温馨提示',
					  message: '您确定要开通扫码点餐吗？',
					}).then(() => {

					  this.openCode()
					}).catch(() => {
					  // on cancel
					});
			  }
            
          },
		  openCode(){
		    var toast = Toast.loading({
		      message: '正在开通',
		      forbidClick: true,
		      loadingType: 'spinner',
		    });
		    this.$http.get('/wechat/api.store.index/openCode', {
		      params: {
		        // openid:window.localStorage.getItem("openid"),
				id: window.sessionStorage.getItem("store_id"),
		  
		      }
		    }).then(response => {
				if (response && response.body.code== 200) {
				    Notify({type: 'success', message: response.body.msg});
				    setTimeout(()=>{
				        this.$router.go(0)
				    },200)
				
				}else {
				    Notify({type: 'danger',message:response.body.msg});
				}
		  
		    })
		  },
		  close_code(type){
			  var swch = 0;
			  switch (type){
			  	case 'close_wechat':
					swch = this.close_wechat ? 1 : 0;
			  		break;
				case 'close_alipay':
					swch = this.close_alipay ? 1 : 0;
					break;
				case 'close_unionpay':
					swch = this.close_unionpay ? 1 : 0;
					break;
			  	default:
					
			  		break;
			  }
			  this.$http.get('/wechat/api.store.index/closeCode', {
			    params: {
			      type:type,
				  switch:swch
			  		  
			    }
			  }).then(response => {
			  	if (response && response.body.code== 200) {
			  	    Notify({type: 'success', message: response.body.msg});
			  	    setTimeout(()=>{
			  	        // this.$router.go(0)
			  	    },200)
			  	
			  	}else {
			  	    Notify({type: 'danger',message:response.body.msg});
			  	}
			  		  
			  })
		  },



          sign_store(){
            Dialog.confirm({
              title: '温馨提示',
              message: '您确定要解除绑定吗？',
            }).then(() => {

              this.Logwechat()
            })
                .catch(() => {
                  // on cancel
                });
          },

          Logwechat(){
            var toast = Toast.loading({
              duration: 0,
              message: '正在解绑',
              forbidClick: true,
              loadingType: 'spinner',
            });
            this.$http.delete('/wechat/api.store.index/unBindAccount', {
              params: {
                openid:window.localStorage.getItem("openid"),

              }
            }).then(response => {
              // 跳转至登陆界面
              toast.clear();
              sessionStorage.clear();
              console.log("退出成功"+response.data);
              var toas = Toast.loading({
                duration: 0,
                message: "解绑成功",
                forbidClick: true,
                loadingType: 'spinner',
              });
              this.$router.push("/StoreImpower");
              setTimeout(function(){
                toas.clear();
              }, 1000);

            })
          },




            // 退出登录
            sign_out() {
                Dialog.confirm({
                    title: '温馨提示',
                    message: '您确定要退出吗？',
                }).then(() => {

                    this.Logout()
                    })
                    .catch(() => {
                        // on cancel
                    });
            },

            // 退出登录请求
            Logout(){
                  var toast = Toast.loading({
                    duration: 0,
                    message: '正在退出',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                   this.$http.get('/wechat/user/store_logout', {
                     params: {
                        store_id:window.sessionStorage.getItem("store_id"),
                    }
                }).then(response => {
                    // 跳转至登陆界面
                     toast.clear();
                    sessionStorage.clear();
                    console.log("退出成功"+response.data);
                    this.$router.push("/StoreImpower");

                })
           },
        },
    }
</script>

<style scoped>
    /*标题整体*/
    .topbar {
        background: #00aaee;
        color: #fff;
        padding: 13px 0;
        width: 100%;
        text-align: center;
    }
</style>
